import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  styled,
} from "@mui/material";
import { Iconify } from "..";
import { PropsWithChildren, ReactNode } from "react";
import { useTranslations } from "next-intl";

interface FormAccordionProps extends PropsWithChildren {
  title: ReactNode;
  expanded?: boolean;
}

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: "0.5rem",
  padding: theme.spacing(0.5),
  "&.MuiExpansionPanel-root:before": {
    display: "none",
  },
  "&:before": {
    display: "none",
  },
  width: "100%",
}));

export const FormAccordion = ({
  title,
  children,
  expanded,
}: FormAccordionProps) => {
  const t = useTranslations();
  return (
    <StyledAccordion
      expanded={expanded}
      disableGutters
      elevation={0}
      defaultExpanded
    >
      <AccordionSummary expandIcon={<Iconify icon="tabler:chevron-down" />}>
        <Typography
          fontWeight="700"
          fontSize="1rem"
          width="100%"
          textTransform="capitalize"
        >
          {typeof title === "string" ? t(title) : title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
};
